export const globalQueryKeyReferralCode = 'ref';
export const globalQueryKeyScaleoReferralCode = 'cid';
